<div class="orca-dialog">
    <div class="dialog-header">
        <h1 class="dialog-title">Verificação de Conta</h1>

        <div class="dialog-btn-close">
            <button mat-icon-button (click)="close()" [disabled]="verificationLoading" aria-label="Fechar">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>

    <div class="dialog-content">
        <app-first-access-email-verification-step
            (loadingChange)="onLoadingChange($event)">
        </app-first-access-email-verification-step>
    </div>

    <div class="dialog-footer">
        <div class="dialog-actions">
            <button class="btn btn-blue" (click)="close()" [disabled]="verificationLoading">
                Concluir
            </button>
        </div>
    </div>
</div>
